export const platforms = [
  {
    name: "Hipobuy Spreadsheet",
    slug: "hipobuy-spreadsheet",
    description: "The premier destination for organized product discovery. Hipobuy spreadsheet resources offer comprehensive category breakdowns, detailed product comparisons, and regularly updated information to help shoppers make informed decisions efficiently.",
    features: ["Regularly updated listings", "Comprehensive category coverage", "User-friendly organization", "Detailed product comparisons"],
    imageSeq: "platform-hipobuy-01",
    rating: 4.8,
  },
  {
    name: "Kakobuy Spreadsheet",
    slug: "kakobuy-spreadsheet",
    description: "A growing spreadsheet platform known for its extensive product database and community-driven updates. Kakobuy spreadsheet resources provide alternative perspectives for cross-referencing product information.",
    features: ["Community-driven updates", "Extensive product database", "Alternative perspective", "Cross-reference capability"],
    imageSeq: "platform-kakobuy-01",
    rating: 4.5,
  },
  {
    name: "CSSBuy Spreadsheet",
    slug: "cssbuy-spreadsheet",
    description: "A trusted spreadsheet resource with a focus on transparency and detailed product documentation. CSSBuy spreadsheet listings are valued for their accuracy and thorough item descriptions.",
    features: ["Transparent listings", "Detailed documentation", "Accurate information", "Thorough descriptions"],
    imageSeq: "platform-cssbuy-01",
    rating: 4.6,
  },
  {
    name: "Superbuy Spreadsheet",
    slug: "superbuy-spreadsheet",
    description: "An established spreadsheet platform offering a wide range of product categories and reliable information. Superbuy spreadsheet resources are popular among experienced shoppers for their consistency.",
    features: ["Wide category range", "Reliable information", "Experienced shopper favorite", "Consistent updates"],
    imageSeq: "platform-superbuy-01",
    rating: 4.7,
  },
  {
    name: "Oopbuy Spreadsheet",
    slug: "oopbuy-spreadsheet",
    description: "An emerging spreadsheet resource gaining popularity for its innovative organization methods and fresh product discoveries. Oopbuy spreadsheet listings provide unique finds and alternative shopping angles.",
    features: ["Innovative organization", "Fresh discoveries", "Unique product finds", "Alternative shopping angles"],
    imageSeq: "platform-oopbuy-01",
    rating: 4.4,
  },
];